import { IApiResponse } from "../../../@types/api-response.type";
import { IApiChart } from "../../../@types/chart.type";
import { Api } from "../ApiConfig";
import { ApiException } from "../ApiException";
import { getErrorMessage } from "../../../utils/utils";

export const addOrUpdateWidgetUser = async (widgetChart: IApiChart) => {
  try {
    const { data } = await Api.post(`/api/WidgetUser/AddOrUpdate`, widgetChart);
    return data;
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao criar o widget'));
  }
};

export const deleteWidgetUser = async (idWidget: string) => {
  try {
    const { data } = await Api.delete(`/api/WidgetUser/Delete/${idWidget}`);
    return data;
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao deletar o widget'));
  }
};

export const getAllWidgetsByUserId = async (useId: string) => {
  try {
    const { data } = await Api.get(`/api/WidgetUser/GetAllByUserId/${useId}`);
    return data;
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar os widgets'));
  }
};

export const getWidgetById = async (widgetId: string) => {
  try {
    const { data } = await Api.get<IApiResponse<IApiChart>>(
      `/api/WidgetUser/GetById/${widgetId}`
    );
    return data;
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar o widget'));
  }
};
